export function env(key: string): string {
  if (key === 'NEXT_PUBLIC_ASSIDUOUS_API_URL') return '/v1'
  if (key === 'NEXT_PUBLIC_HOTJAR_SITE_ID') {
    return import.meta.env.VITE_HOTJAR_SITE_ID || ''
  }
  return ''
}
